import { ComponentProps, useEffect, useState } from 'react'
import { OverlayKYCWrapperProps } from './OverlayKYCWrapper.types'
import FlowPrerequirementsProvider, {
  usePendingSteps,
} from 'context/FlowPrerequirements'
import StandalonePrereqLogic from 'features/FlowPrerequirements/StandalonePrereq'
import useRouteGalleryOrDefault from 'openspace/hooks/useRoutePathGallery'
import Loader from '@onepercentio/one-ui/components/Loader'
import Styles from './OverlayKYCWrapper.module.scss'
import RarumDialog from '../RarumDialog'
import { t } from 'translate/i18n'
import Text from '../Text'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import Transitions from 'components/Transitions'

export default function OverlayKYCWrapperLogic(
  props: OverlayKYCWrapperProps &
    Pick<ComponentProps<typeof FlowPrerequirementsProvider>, 'requirement'>
) {
  return (
    <FlowPrerequirementsProvider requirement={props.requirement}>
      <OverlayKYCWrapper {...props} />
    </FlowPrerequirementsProvider>
  )
}
function OverlayKYCWrapper(props: OverlayKYCWrapperProps) {
  const pendingSteps = usePendingSteps(undefined)
  const gallery = useRouteGalleryOrDefault()
  const [isEnabled, setIsEnabled] = useState(false)

  if (!gallery) return <Loader />
  if (!pendingSteps.length) return props.children
  return (
    <Transitions>
      {isEnabled ? (
        <StandalonePrereqLogic
          prereqTo={props.prereqTo}
          galleryId={gallery?.id}
          key={'kyc'}
          shouldRequestDataConsent={false}
          onBack={() => setIsEnabled(false)}>
          {props.children}
        </StandalonePrereqLogic>
      ) : (
        <div className={Styles.root} key={'confirm'}>
          {props.children}
          <RarumDialog
            open={!isEnabled}
            title={['time', t('marketplace.offerCreation.sections.kyc.title')]}
            confirm={[
              t('marketplace.offerCreation.sections.kyc.actions.verify'),
              () => setIsEnabled(true),
            ]}
            cancel={[t('generic.cancel'), props.onClose]}
            inline>
            <Text
              code='marketplace.offerCreation.sections.kyc.description'
              type={LPTypo.P1}
            />
          </RarumDialog>
        </div>
      )}
    </Transitions>
  )
}
